export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkHistoria: "nav-link-historia",
  linkHerramientas: "nav-link-herramientas",
  linkBlog: "nav-link-blog",
  linkContacto: "nav-link-contacto",
  ctaPrecalificacion: "nav-cta-precalificacion",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  question: "hero-question",
  category: (slug) => `hero-category-${slug}`,
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};

export const PREQUAL = {
  step: (n) => `prequal-step-${n}`,
  next: "prequal-next",
  prev: "prequal-prev",
  submit: "prequal-submit",
  field: (name) => `prequal-field-${name}`,
};

export const TOOLS = {
  tabRetiro: "tool-tab-retiro",
  tabProteccion: "tool-tab-proteccion",
  tabCoberturas: "tool-tab-coberturas",
  retiroEdad: "tool-retiro-edad",
  retiroAhorro: "tool-retiro-ahorro",
  retiroAporte: "tool-retiro-aporte",
  retiroResult: "tool-retiro-result",
  proteccionIngresos: "tool-proteccion-ingresos",
  proteccionDependientes: "tool-proteccion-dependientes",
  proteccionResult: "tool-proteccion-result",
  coberturaPerfil: "tool-cobertura-perfil",
  coberturaResult: "tool-cobertura-result",
};

export const CONTACT = {
  form: "contact-form",
  submit: "contact-submit",
  field: (name) => `contact-field-${name}`,
  whatsappFloat: "whatsapp-float",
};
